import React, { useState } from 'react';
import './FlipCard.css';

const FlipCard = ({ question, answer }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`flip-card ${flipped ? 'flipped' : ''}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <h4>{question}</h4>
        </div>
        <div className="flip-card-back">
          <h4>Expert Answer</h4>
          <div className="flip-card-text">{answer}</div>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
